import { DEFAULT_PER_PAGE } from "./default";

function isNumber(s) {
    const num = Number(s);
    if (num === null) {
        return false;
    }
    if (isNaN(Number(num))) {
        return false;
    }
    return typeof num === 'number';
}


function paginationCounting({ page, per_page = DEFAULT_PER_PAGE, totals }) {
    const startItem = (page - 1) * per_page + 1;
    const endItem = Math.min(page * per_page, totals);


    return {
        startItem, endItem,
    }
}

export { isNumber, paginationCounting }